module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "newPrize"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_vm._v("\n    活动管理 > 奖品管理 >\n    "), (_vm.edit === false) ? _c('span', [_vm._v("新增")]) : _vm._e(), _vm._v(" "), (_vm.edit !== false) ? _c('span', [_vm._v("编辑")]) : _vm._e(), _vm._v(" "), _c('span', [_c('el-button', {
    staticClass: "right_f",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    staticClass: "right_f",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("保存")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_c('el-form', {
    ref: "prizeForm",
    attrs: {
      "rules": _vm.rules,
      "model": _vm.prizeForm,
      "label-width": "160px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "奖品图标：",
      "prop": "logoUrl"
    }
  }, [_c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "action": _vm.actionUrl,
      "with-credentials": true,
      "accept": "image/*",
      "name": "uploadFile",
      "type": "drag",
      "thumbnail-mode": true,
      "on-error": _vm.handleError,
      "on-success": _vm.handleSuccess,
      "show-file-list": false
    }
  }, [(_vm.prizeForm.logoUrl) ? _c('img', {
    staticClass: "avatar",
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": _vm.prizeForm.logoUrl
    }
  }) : _c('div', [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-dragger__text"
  }, [_vm._v("\n              将文件拖到此处，或\n              "), _c('em', [_vm._v("点击上传")])])])])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "奖品名称：",
      "prop": "prizeName"
    }
  }, [_c('el-input', {
    staticClass: "prizeTitle",
    attrs: {
      "placeholder": "请仔细填写，在APP展示给用户"
    },
    model: {
      value: (_vm.prizeForm.prizeName),
      callback: function($$v) {
        _vm.$set(_vm.prizeForm, "prizeName", $$v)
      },
      expression: "prizeForm.prizeName"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("奖品名称建议8个字符")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "发放时间：",
      "required": ""
    }
  }, [_c('el-date-picker', {
    staticClass: "qizhiDate",
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "format": "yyyy/MM/dd HH:mm",
      "type": "datetime",
      "placeholder": "yyyy/MM/dd hh:mm"
    },
    model: {
      value: (_vm.prizeForm.deployStartTime),
      callback: function($$v) {
        _vm.$set(_vm.prizeForm, "deployStartTime", $$v)
      },
      expression: "prizeForm.deployStartTime"
    }
  }), _vm._v(" "), _vm._v("\n         至 \n        "), _vm._v(" "), _c('el-date-picker', {
    staticClass: "qizhiDate",
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "datetime",
      "format": "yyyy/MM/dd HH:mm",
      "placeholder": "yyyy/MM/dd hh:mm"
    },
    model: {
      value: (_vm.prizeForm.deployEndTime),
      callback: function($$v) {
        _vm.$set(_vm.prizeForm, "deployEndTime", $$v)
      },
      expression: "prizeForm.deployEndTime"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "奖品类型："
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "20%"
    },
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.prizeForm.prizeType),
      callback: function($$v) {
        _vm.$set(_vm.prizeForm, "prizeType", $$v)
      },
      expression: "prizeForm.prizeType"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "一级奖励（必中）",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "一级奖励（限量）",
      "value": "3"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "二级奖励（随机）",
      "value": "2"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "奖励弹窗:",
      "required": ""
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.prizeForm.windowType),
      callback: function($$v) {
        _vm.$set(_vm.prizeForm, "windowType", $$v)
      },
      expression: "prizeForm.windowType"
    }
  }, [_vm._v("默认")]), _vm._v(" "), _c('el-radio', {
    staticStyle: {
      "margin-left": "0"
    },
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.prizeForm.windowType),
      callback: function($$v) {
        _vm.$set(_vm.prizeForm, "windowType", $$v)
      },
      expression: "prizeForm.windowType"
    }
  }, [_vm._v("自定义")]), _vm._v(" "), (_vm.prizeForm.windowType == 1) ? _c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "action": _vm.actionUrl,
      "with-credentials": true,
      "accept": "image/*",
      "name": "uploadFile",
      "type": "drag",
      "thumbnail-mode": true,
      "on-error": _vm.handleError,
      "on-success": _vm.handleSuccess2,
      "show-file-list": false
    }
  }, [(_vm.prizeForm.windowUrl) ? _c('img', {
    staticClass: "avatar",
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": _vm.prizeForm.windowUrl
    }
  }) : _c('div', [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-dragger__text"
  }, [_vm._v("\n              将文件拖到此处，或\n              "), _c('em', [_vm._v("点击上传")])])])]) : _vm._e()], 1), _vm._v(" "), (_vm.prizeForm.windowType == '1') ? _c('el-form-item', {
    staticClass: "click-events",
    attrs: {
      "label": "点击事件:",
      "prop": "windowClickType",
      "required": ""
    }
  }, [_c('el-radio', {
    staticStyle: {
      "margin-left": "15px"
    },
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.prizeForm.windowClickType),
      callback: function($$v) {
        _vm.$set(_vm.prizeForm, "windowClickType", $$v)
      },
      expression: "prizeForm.windowClickType"
    }
  }, [_vm._v("无跳转")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.prizeForm.windowClickType),
      callback: function($$v) {
        _vm.$set(_vm.prizeForm, "windowClickType", $$v)
      },
      expression: "prizeForm.windowClickType"
    }
  }, [_vm._v("跳转至URL：")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "2"
    },
    model: {
      value: (_vm.prizeForm.windowClickType),
      callback: function($$v) {
        _vm.$set(_vm.prizeForm, "windowClickType", $$v)
      },
      expression: "prizeForm.windowClickType"
    }
  }, [_vm._v("跳转至已有文章：")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "3"
    },
    model: {
      value: (_vm.prizeForm.windowClickType),
      callback: function($$v) {
        _vm.$set(_vm.prizeForm, "windowClickType", $$v)
      },
      expression: "prizeForm.windowClickType"
    }
  }, [_vm._v("跳转至已有话题：")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "4"
    },
    model: {
      value: (_vm.prizeForm.windowClickType),
      callback: function($$v) {
        _vm.$set(_vm.prizeForm, "windowClickType", $$v)
      },
      expression: "prizeForm.windowClickType"
    }
  }, [_vm._v("跳转至微信小程序：")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "7"
    },
    model: {
      value: (_vm.prizeForm.windowClickType),
      callback: function($$v) {
        _vm.$set(_vm.prizeForm, "windowClickType", $$v)
      },
      expression: "prizeForm.windowClickType"
    }
  }, [_vm._v("跳转至支付宝小程序：")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "5"
    },
    model: {
      value: (_vm.prizeForm.windowClickType),
      callback: function($$v) {
        _vm.$set(_vm.prizeForm, "windowClickType", $$v)
      },
      expression: "prizeForm.windowClickType"
    }
  }, [_vm._v("跳转至音频：")]), _vm._v(" "), (_vm.shieldArray2.indexOf(_vm.prizeForm.windowClickType) > -1) ? _c('el-input', {
    staticClass: "activityTitle",
    attrs: {
      "placeholder": _vm.placeholder
    },
    model: {
      value: (_vm.prizeForm.windowClickUrl),
      callback: function($$v) {
        _vm.$set(_vm.prizeForm, "windowClickUrl", $$v)
      },
      expression: "prizeForm.windowClickUrl"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.prizeForm.windowType == '1' && _vm.prizeForm.windowClickType == '4') ? _c('div', {
    staticClass: "wx-app"
  }, [_c('el-form-item', {
    staticClass: "wxApp-from",
    attrs: {
      "label": "小程序原始Id：",
      "prop": "wxAppId",
      "required": ""
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "placeholder": "请填写正确的小程序原始Id"
    },
    model: {
      value: (_vm.prizeForm.wxAppId),
      callback: function($$v) {
        _vm.$set(_vm.prizeForm, "wxAppId", $$v)
      },
      expression: "prizeForm.wxAppId"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "wxApp-from",
    attrs: {
      "label": "路径地址：",
      "prop": "wxAppUrl"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "placeholder": "请填写正确的路径地址"
    },
    model: {
      value: (_vm.prizeForm.wxAppUrl),
      callback: function($$v) {
        _vm.$set(_vm.prizeForm, "wxAppUrl", $$v)
      },
      expression: "prizeForm.wxAppUrl"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.prizeForm.windowType == '1' && _vm.prizeForm.windowClickType == '7') ? _c('div', {
    staticClass: "wx-app"
  }, [_c('el-form-item', {
    staticClass: "wxApp-from",
    attrs: {
      "label": "小程序原始Id：",
      "prop": "aliAppId",
      "required": ""
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "placeholder": "请填写正确的小程序原始Id"
    },
    model: {
      value: (_vm.prizeForm.aliAppId),
      callback: function($$v) {
        _vm.$set(_vm.prizeForm, "aliAppId", $$v)
      },
      expression: "prizeForm.aliAppId"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "wxApp-from",
    attrs: {
      "label": "路径地址：",
      "prop": "aliAppUrl"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "placeholder": "请填写正确的路径地址"
    },
    model: {
      value: (_vm.prizeForm.aliAppUrl),
      callback: function($$v) {
        _vm.$set(_vm.prizeForm, "aliAppUrl", $$v)
      },
      expression: "prizeForm.aliAppUrl"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.prizeForm.windowType == '1' && _vm.prizeForm.windowClickType == '5') ? _c('div', {
    staticClass: "wx-app"
  }, [_c('el-form-item', {
    staticClass: "wxApp-from",
    attrs: {
      "label": "专辑ID：",
      "prop": "albumId",
      "required": ""
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "placeholder": "请填写专辑ID"
    },
    model: {
      value: (_vm.prizeForm.albumId),
      callback: function($$v) {
        _vm.$set(_vm.prizeForm, "albumId", $$v)
      },
      expression: "prizeForm.albumId"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "wxApp-from wx-app",
    staticStyle: {
      "margin-bottom": "22px"
    },
    attrs: {
      "label": "主播名称：",
      "prop": "nickName",
      "required": ""
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "placeholder": "请填写主播名称"
    },
    model: {
      value: (_vm.prizeForm.nickName),
      callback: function($$v) {
        _vm.$set(_vm.prizeForm, "nickName", $$v)
      },
      expression: "prizeForm.nickName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "wxApp-from",
    attrs: {
      "label": "单曲数：",
      "prop": "albumCount",
      "required": ""
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "placeholder": "请填写单曲数",
      "type": "number"
    },
    model: {
      value: (_vm.prizeForm.albumCount),
      callback: function($$v) {
        _vm.$set(_vm.prizeForm, "albumCount", $$v)
      },
      expression: "prizeForm.albumCount"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "wxApp-from",
    attrs: {
      "label": "是否付费：",
      "prop": "isPaid",
      "required": ""
    }
  }, [_c('el-radio', {
    staticStyle: {
      "margin-left": "15px"
    },
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.prizeForm.isPaid),
      callback: function($$v) {
        _vm.$set(_vm.prizeForm, "isPaid", $$v)
      },
      expression: "prizeForm.isPaid"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.prizeForm.isPaid),
      callback: function($$v) {
        _vm.$set(_vm.prizeForm, "isPaid", $$v)
      },
      expression: "prizeForm.isPaid"
    }
  }, [_vm._v("否")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "奖励里程：",
      "prop": "prizeDisType"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.prizeForm.prizeDisType),
      callback: function($$v) {
        _vm.$set(_vm.prizeForm, "prizeDisType", $$v)
      },
      expression: "prizeForm.prizeDisType"
    }
  }, [_vm._v("不奖励")]), _vm._v(" "), _c('el-radio', {
    staticClass: "inline",
    staticStyle: {
      "margin-left": "0"
    },
    attrs: {
      "label": "2"
    },
    model: {
      value: (_vm.prizeForm.prizeDisType),
      callback: function($$v) {
        _vm.$set(_vm.prizeForm, "prizeDisType", $$v)
      },
      expression: "prizeForm.prizeDisType"
    }
  }, [_vm._v("双倍")]), _vm._v(" "), _c('el-radio', {
    staticClass: "inline",
    attrs: {
      "label": "3"
    },
    model: {
      value: (_vm.prizeForm.prizeDisType),
      callback: function($$v) {
        _vm.$set(_vm.prizeForm, "prizeDisType", $$v)
      },
      expression: "prizeForm.prizeDisType"
    }
  }, [_vm._v("自定义")]), _vm._v(" "), (_vm.prizeForm.prizeDisType == '3') ? _c('div', {
    staticStyle: {
      "display": "flex",
      "flex-direction": "column",
      "gap": "10px"
    }
  }, [_c('el-input', {
    staticClass: "prizekm",
    attrs: {
      "type": "number",
      "min": "0",
      "placeholder": "请输入奖励公里数"
    },
    model: {
      value: (_vm.prizeForm.prizeDis),
      callback: function($$v) {
        _vm.$set(_vm.prizeForm, "prizeDis", $$v)
      },
      expression: "prizeForm.prizeDis"
    }
  }), _vm._v(" "), _c('el-input', {
    staticClass: "prizekm",
    attrs: {
      "type": "number",
      "min": "1",
      "placeholder": "请输入奖励次数"
    },
    model: {
      value: (_vm.prizeForm.prizeTimes),
      callback: function($$v) {
        _vm.$set(_vm.prizeForm, "prizeTimes", $$v)
      },
      expression: "prizeForm.prizeTimes"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "兑奖URL：",
      "prop": "prizeUrl"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "false"
    },
    model: {
      value: (_vm.prizeForm.definePrizeUrl),
      callback: function($$v) {
        _vm.$set(_vm.prizeForm, "definePrizeUrl", $$v)
      },
      expression: "prizeForm.definePrizeUrl"
    }
  }, [_vm._v("同活动详情URL（若无活动详情URL则不跳转，请检查确认）")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-radio', {
    staticClass: "inline",
    attrs: {
      "label": "true"
    },
    model: {
      value: (_vm.prizeForm.definePrizeUrl),
      callback: function($$v) {
        _vm.$set(_vm.prizeForm, "definePrizeUrl", $$v)
      },
      expression: "prizeForm.definePrizeUrl"
    }
  }, [_vm._v("自定义URL")]), _vm._v(" "), (_vm.prizeForm.definePrizeUrl == 'true') ? _c('el-input', {
    staticClass: "prizeTitle",
    model: {
      value: (_vm.prizeForm.prizeUrl),
      callback: function($$v) {
        _vm.$set(_vm.prizeForm, "prizeUrl", $$v)
      },
      expression: "prizeForm.prizeUrl"
    }
  }) : _vm._e(), _c('br'), _vm._v(" "), (_vm.prizeForm.definePrizeUrl == 'true') ? _c('span', {
    staticStyle: {
      "color": "#666"
    }
  }, [_vm._v("配置微信小程序URL示例：zjwh://weChatProgram?id="), _c('span', {
    staticClass: "red"
  }, [_vm._v("111111")]), _vm._v("\n          或者 zjwh://weChatProgram?id="), _c('span', {
    staticClass: "red"
  }, [_vm._v("111111")]), _vm._v("&path="), _c('span', {
    staticClass: "red"
  }, [_vm._v("111111")])]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "prizeTitle",
    attrs: {
      "label": "第三方奖励ID：",
      "prop": "defineText1"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": ""
    },
    model: {
      value: (_vm.prizeForm.defineText1),
      callback: function($$v) {
        _vm.$set(_vm.prizeForm, "defineText1", $$v)
      },
      expression: "prizeForm.defineText1"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "prizeContent",
    attrs: {
      "label": "广告曝光代码：",
      "prop": "adExposingCodes"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 5
      },
      "placeholder": "在这里粘贴"
    },
    model: {
      value: (_vm.prizeForm.adExposingCodes),
      callback: function($$v) {
        _vm.$set(_vm.prizeForm, "adExposingCodes", $$v)
      },
      expression: "prizeForm.adExposingCodes"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "文案：",
      "prop": "redeem"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "true",
      "disabled": _vm.isDisabled
    },
    model: {
      value: (_vm.prizeForm.redeem),
      callback: function($$v) {
        _vm.$set(_vm.prizeForm, "redeem", $$v)
      },
      expression: "prizeForm.redeem"
    }
  }, [_vm._v("兑换码类型")]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.prizeForm.redeem == 'true') ? _c('el-form-item', {
    attrs: {
      "label": "文字说明：",
      "label-width": "100px",
      "prop": "redeemText"
    }
  }, [_c('el-input', {
    staticClass: "prizeText",
    staticStyle: {
      "min-width": "200px",
      "display": "inline-block"
    },
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 4
      }
    },
    model: {
      value: (_vm.prizeForm.redeemText),
      callback: function($$v) {
        _vm.$set(_vm.prizeForm, "redeemText", $$v)
      },
      expression: "prizeForm.redeemText"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-radio', {
    staticClass: "inline",
    attrs: {
      "label": "false"
    },
    model: {
      value: (_vm.prizeForm.redeem),
      callback: function($$v) {
        _vm.$set(_vm.prizeForm, "redeem", $$v)
      },
      expression: "prizeForm.redeem"
    }
  }, [_vm._v("自定义文案")]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.prizeForm.redeem == 'false') ? _c('el-form-item', {
    attrs: {
      "label": "文案内容：",
      "label-width": "100px",
      "prop": "defineText2"
    }
  }, [_c('el-input', {
    staticClass: "prizeText",
    staticStyle: {
      "min-width": "200px",
      "display": "inline-block"
    },
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 4
      }
    },
    model: {
      value: (_vm.prizeForm.defineText2),
      callback: function($$v) {
        _vm.$set(_vm.prizeForm, "defineText2", $$v)
      },
      expression: "prizeForm.defineText2"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "奖品兑换有效期：",
      "prop": "qizhiDate"
    }
  }, [_c('el-date-picker', {
    staticClass: "qizhiDate",
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "format": "yyyy/MM/dd",
      "placeholder": "yyyy/MM/dd"
    },
    model: {
      value: (_vm.prizeForm.redeemStartTime),
      callback: function($$v) {
        _vm.$set(_vm.prizeForm, "redeemStartTime", $$v)
      },
      expression: "prizeForm.redeemStartTime"
    }
  }), _vm._v(" "), _vm._v("\n        至 \n        "), _vm._v(" "), _c('el-date-picker', {
    staticClass: "qizhiDate",
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "format": "yyyy/MM/dd",
      "placeholder": "yyyy/MM/dd"
    },
    model: {
      value: (_vm.prizeForm.redeemEndTime),
      callback: function($$v) {
        _vm.$set(_vm.prizeForm, "redeemEndTime", $$v)
      },
      expression: "prizeForm.redeemEndTime"
    }
  }), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.clearTime
    }
  }, [_vm._v("清空时间")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "奖品详细数据：",
      "prop": "uploadFile"
    }
  }, [(_vm.prizeForm.prizeType != 3) ? _c('div', [(_vm.isable === true) ? _c('el-upload', {
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "action": _vm.importUrlAction,
      "with-credentials": true,
      "on-success": _vm.success,
      "on-error": _vm.handleError,
      "name": "uploadFile"
    }
  }, [_c('el-button', [_vm._v("选择文件")])], 1) : _vm._e(), _vm._v(" "), (_vm.isable === false) ? _c('el-button', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("选择文件")]) : _vm._e(), _vm._v(" "), (_vm.prizeForm.prizeType == '2') ? _c('span', [_vm._v("(" + _vm._s(_vm.prizeForm.import) + ")")]) : _vm._e(), _vm._v(" "), (_vm.prizeForm.prizeType == '1') ? _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("必中奖品数量不限，无需导入文件")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.prizeForm.prizeType == 3) ? _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-radio', {
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.prizeForm.prizeFromType),
      callback: function($$v) {
        _vm.$set(_vm.prizeForm, "prizeFromType", $$v)
      },
      expression: "prizeForm.prizeFromType"
    }
  }, [_vm._v("总共")]), _vm._v(" "), (_vm.prizeForm.prizeFromType == '1') ? _c('div', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.prizeForm.prizeNum),
      expression: "prizeForm.prizeNum"
    }],
    staticStyle: {
      "outline": "none"
    },
    domProps: {
      "value": (_vm.prizeForm.prizeNum)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.prizeForm, "prizeNum", $event.target.value)
      }
    }
  }), _vm._v(" 个\n              （所有参与学校均可领取）\n            ")]) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-radio', {
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "label": "2"
    },
    model: {
      value: (_vm.prizeForm.prizeFromType),
      callback: function($$v) {
        _vm.$set(_vm.prizeForm, "prizeFromType", $$v)
      },
      expression: "prizeForm.prizeFromType"
    }
  }, [_vm._v("每个学校")]), _vm._v(" "), (_vm.prizeForm.prizeFromType == '2') ? _c('div', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.prizeForm.prizeNum),
      expression: "prizeForm.prizeNum"
    }],
    staticStyle: {
      "outline": "none"
    },
    domProps: {
      "value": (_vm.prizeForm.prizeNum)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.prizeForm, "prizeNum", $event.target.value)
      }
    }
  }), _vm._v(" 个\n            ")]) : _vm._e()], 1), _vm._v(" "), (_vm.isable === true) ? _c('el-upload', {
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "action": _vm.importUrlAction2,
      "with-credentials": true,
      "on-success": _vm.success,
      "on-error": _vm.handleError,
      "name": "uploadFile"
    }
  }, [_c('el-button', [_vm._v("选择文件")])], 1) : _vm._e(), _vm._v(" "), (_vm.isable === false) ? _c('el-button', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("选择文件")]) : _vm._e(), _vm._v(" "), (_vm.prizeForm.prizeType == '3') ? _c('span', [_vm._v("(" + _vm._s(_vm.prizeForm.import) + ")")]) : _vm._e()], 1) : _vm._e()], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5d190637!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/yunying/activity/newPrize.vue
// module id = 1041
// module chunks = 0